/*
 * File: cell-string.ts
 * File Created: 2023-12-18 04:51:11
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 08:50:23
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "../../../core/lib/base-table-body-cell/base-table-body-cell";
import { AnyHelper, DateHelper, NumberHelper } from "@root/core";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiSort: true,
    uiSearch: true,
})
export default class CellString extends BaseTableBodyCell {
    /// private helper
    get localeString() {
        /// firstly, make default value for below types.
        let rtn =
            // Date
            this.value instanceof Date
                ? DateHelper.toString(this.value)
                : // boolean
                  typeof this.value === "boolean"
                  ? this.$_(`w_${this.value == true ? "Yes" : "No"}`)
                  : // number
                    typeof this.value === "number"
                    ? NumberHelper.toPrettyString(this.value)
                    : // null
                      this.value == null
                      ? this.$_(this.mergedData["text-empty"])
                      : // else
                        AnyHelper.toString(this.value);

        /// secondly, if the content is HTML, show it correctly.
        const regex_endslash = /\<\//;
        const regex_sp = /\&[a-zA-z]{1-5}\;/;
        /// safe html
        if (regex_endslash.test(rtn) || regex_sp.test(rtn)) return rtn;

        /// translate to text
        const div = document.createElement("div");
        div.appendChild(document.createTextNode(rtn));
        /// finally, attempt to translate it
        return this.$_(div.innerHTML);
    }
}
